// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.od-grid {
  display: grid;
  gap: 18px;
  align-items: start;
}

.od-progress {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-bottom: 18px;
  padding: 15px 17px;
  border-radius: var(--radius);
  background: var(--grad-brand);
  color: #fff;
  text-decoration: none;
  box-shadow: var(--shadow-brand);
  transition: transform 0.15s;
}

.od-progress:hover {
  transform: translateY(-2px);
}

.od-progress strong {
  display: block;
  font-family: var(--font-display);
  font-size: 0.98rem;
}

.od-progress span {
  font-size: 0.84rem;
  color: rgba(255, 255, 255, 0.85);
}

.od-auction {
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-color: var(--brand-100);
  background: linear-gradient(180deg, var(--brand-50) 0%, var(--surface) 100%);
}

.od-auction-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.od-auction-ico {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: var(--radius-sm);
  background: var(--brand);
  color: #fff;
}

.od-auction-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.od-auction-stats div {
  flex: 1 1;
  min-width: 96px;
  padding: 11px 13px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
}

.od-auction-stats strong {
  display: block;
  font-family: var(--font-display);
  font-size: 1.06rem;
  font-weight: 800;
  line-height: 1.2;
  color: var(--text);
}

.od-auction-stats span {
  font-size: 0.75rem;
  color: var(--muted);
}

.od-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 13px;
}

.od-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  margin-left: 5px;
  padding: 0 6px;
  border-radius: var(--radius-pill);
  background: var(--brand);
  color: #fff;
  font-size: 0.74rem;
  font-weight: 700;
}

.od-refresh {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: none;
  padding: 0;
  font-size: 0.84rem;
  font-weight: 600;
  color: var(--brand);
  cursor: pointer;
}

.od-refresh:hover:not(:disabled) {
  text-decoration: underline;
}

.od-refresh:disabled {
  opacity: 0.6;
  cursor: default;
}

.od-desc {
  margin-top: 8px;
  font-size: 0.89rem;
  line-height: 1.65;
  color: var(--text-soft);
  white-space: pre-wrap;
}

.od-danger:hover:not(:disabled) {
  border-color: var(--danger-100);
  background: var(--danger-50);
  color: var(--danger);
}

.od-created {
  font-size: 0.78rem;
  color: var(--muted2);
  text-align: center;
}

@media (min-width: 900px) {
  .od-grid {
    grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
    gap: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/client/OrderDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;IACE,sDAAsD;IACtD,SAAS;EACX;AACF","sourcesContent":[".od-grid {\n  display: grid;\n  gap: 18px;\n  align-items: start;\n}\n\n.od-progress {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  margin-bottom: 18px;\n  padding: 15px 17px;\n  border-radius: var(--radius);\n  background: var(--grad-brand);\n  color: #fff;\n  text-decoration: none;\n  box-shadow: var(--shadow-brand);\n  transition: transform 0.15s;\n}\n\n.od-progress:hover {\n  transform: translateY(-2px);\n}\n\n.od-progress strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 0.98rem;\n}\n\n.od-progress span {\n  font-size: 0.84rem;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.od-auction {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  border-color: var(--brand-100);\n  background: linear-gradient(180deg, var(--brand-50) 0%, var(--surface) 100%);\n}\n\n.od-auction-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.od-auction-ico {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: var(--radius-sm);\n  background: var(--brand);\n  color: #fff;\n}\n\n.od-auction-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.od-auction-stats div {\n  flex: 1;\n  min-width: 96px;\n  padding: 11px 13px;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n}\n\n.od-auction-stats strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 1.06rem;\n  font-weight: 800;\n  line-height: 1.2;\n  color: var(--text);\n}\n\n.od-auction-stats span {\n  font-size: 0.75rem;\n  color: var(--muted);\n}\n\n.od-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 13px;\n}\n\n.od-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  margin-left: 5px;\n  padding: 0 6px;\n  border-radius: var(--radius-pill);\n  background: var(--brand);\n  color: #fff;\n  font-size: 0.74rem;\n  font-weight: 700;\n}\n\n.od-refresh {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: none;\n  padding: 0;\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: var(--brand);\n  cursor: pointer;\n}\n\n.od-refresh:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.od-refresh:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.od-desc {\n  margin-top: 8px;\n  font-size: 0.89rem;\n  line-height: 1.65;\n  color: var(--text-soft);\n  white-space: pre-wrap;\n}\n\n.od-danger:hover:not(:disabled) {\n  border-color: var(--danger-100);\n  background: var(--danger-50);\n  color: var(--danger);\n}\n\n.od-created {\n  font-size: 0.78rem;\n  color: var(--muted2);\n  text-align: center;\n}\n\n@media (min-width: 900px) {\n  .od-grid {\n    grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);\n    gap: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
